import { defineStore } from 'pinia'
import { Device } from '@hybird/device'
import { GLOBAL_ENUM } from '@/utils/yky'
import { uploadManager } from '@hybird/device/request'
import bupai from '@/assets/images/record/bupai.png'
import bugai from '@/assets/images/record/bugai.png'
import beforeSeal from '@/assets/images/record/before_seal.png'
import afterSeal from '@/assets/images/record/after_seal.png'
import ocrSeal from '@/assets/images/record/ocr_seal.png'
import { useScanner } from '@/views/device/chooseFileContorl/hooks/useScanner'

export const sealStore = defineStore('seal', {
  state: () => ({
    useQuery: null,
    deviceProtocol: null,
    deviceProtocolBeginSeal: null,
    equipmentLock: null,
    equipmentLockResult: null,
  }),
  actions: {
    setUseQuery(val) {
      this.useQuery = val
    },
    // 设置远程用印所需
    async setDevice(val) {
      this.deviceProtocol = Device.getByNumber(val)?.deviceProtocol
      this.deviceProtocolBeginSeal = await this.deviceProtocol?.beginSeal()
      // console.log(
      //   'deviceProtocolBeginSeal设置成功',
      //   JSON.stringify(this.deviceProtocolBeginSeal)
      // )
    },
    // 设置 远程锁定设备函数
    setEquipmentLock(val) {
      this.equipmentLock = val
    },
    // 设置 远程用印所需回调
    setEquipmentLockResult(val) {
      this.equipmentLockResult = val
      console.log(
        'loackResult设置成功', this.equipmentLockResult
      )
    },
    // 清空远程用印 所需
    clearDevice() {
      this.deviceProtocol = null
      this.deviceProtocolBeginSeal = null
      this.equipmentLock = null
      this.equipmentLockResult = null
    }
  },
})

const { isConnected } = useScanner()

export const useOcrFile = defineStore('ocrFile', {
  state: () => {
    return {
      showProgressFlag: false,
      ocrFile: {},
      ocrCheckPage: GLOBAL_ENUM.OCR_CHECK_PAGE_TYPE.SINGLE_PAGE_CHECK_PAGE, //默认显示单页的
      checkItem: null,
      ocrType: GLOBAL_ENUM.OCR_TYPE.SINGLE_PAGE, //默认显示单页的
      equipmentLockResult: null,
      refreshOcrFileList: null,
      isScanner: false, //是否有扫描仪
      scanResult: [], // 扫描仪上传的结果
      verificationMethod: GLOBAL_ENUM.VERIFICATION_METHOD_TYPE.SCANNER_VERIFICATION_METHOD, // OCR校验图片来源方式
    }
  },
  actions: {
    setOcrFile(val = {}) {
      this.ocrFile = val
    },
    setCheckItem(val = null) {
      this.checkItem = val
    },
    setOcrCheckPage(val = GLOBAL_ENUM.OCR_CHECK_PAGE_TYPE.SINGLE_PAGE_CHECK_PAGE) {
      this.ocrCheckPage = val
    },
    setOcrType(val = GLOBAL_ENUM.OCR_TYPE.SINGLE_PAGE) {
      this.ocrType = val
    },
    setEquipmentLockResult(val = null) {
      console.log(
        'loackResult设置成功', val
      )
      this.equipmentLockResult = val
    },
    setRefreshOcrFileList(val = null) {
      this.refreshOcrFileList = val
    },
    setShowProgressState(val = false) {
      this.showProgressFlag = val
    },
    rest() {
      this.ocrFile = {}
      this.setCheckItem()
      this.setOcrCheckPage()
      this.scanResult = []
      this.setVerificationMethod()
    },
    //是否连接扫描仪
    async findScanner() {
      this.isScanner = await isConnected()
      return this.isScanner
    },
    setVerificationMethod(val = GLOBAL_ENUM.VERIFICATION_METHOD_TYPE.TAKE_PICTURE_VERIFICATION_METHOD) {
      this.verificationMethod = val
    },
  },
  getters: {
    //整份文件是否全通过
    isAllPassThrough: (state) =>
      state.ocrFile.ocrApplyFileVOList.every((item) =>
        [2, 4].includes(item.status)
      ),
  },
})


export const useOcrPageContorl = defineStore('ocrPageContorl', {
  state: () => {
    return {
      components: new Map(), //组件map
      currentLeft: null, //左侧显示组件
      currentRight: null, //右侧显示组件
      stackRecord: [], //记录每次切换
      maxStackSize: 50, //栈最大存储条数
      defaultCom: null, //默认重置显示的组件
      leftHide: false, //左侧是否隐藏
      rightHide: false, //右侧是否隐藏
    }
  },
  actions: {
    //注册组件
    registerComponent(comName, component) {
      console.log('注册ocr组件', comName, component)
      this.components.set(comName, {
        component,
        params: {},
        comName
      })
    },
    //注册所有组件
    registerAllComponent(components = []) {
      if (components instanceof Array) {
        components.forEach(item => this.registerComponent(item.comName, item.component))
        console.log(this.components)
      }
    },
    //切换左侧组件显示
    switchLeft(comName, params = {}, isStackRecord = true) {
      const com = this.components.get(comName)
      if (com) {
        com.params = params
        this.components.set(comName, com)
        this.currentLeft = com
        if (isStackRecord) {
          this.addStackRecord({
            left: this.currentLeft,
            right: this.currentRight
          })
        }
      }
    },
    //切换右侧组件显示
    switchRight(comName, params = {}, isStackRecord = true) {
      const com = this.components.get(comName)
      if (com) {
        com.params = params
        this.components.set(comName, com)
        this.currentRight = com
        if (isStackRecord) {
          this.addStackRecord({
            left: this.currentLeft,
            right: this.currentRight
          })
        }
      }
    },
    //切换两侧组件
    toggle({ left = {}, right = {} }, isStackRecord = true) {
      console.log('切换两侧组件', left, right)
      this.switchLeft(left.comName, left.params, false)
      this.switchRight(right.comName, right.params, false)
      if (isStackRecord) {
        this.addStackRecord({
          left: this.currentLeft,
          right: this.currentRight
        })
      }
    },
    //回退
    back() {
      if (this.stackRecord.length === 0) return
      this.stackRecord.pop()
      const prevRecord = this.stackRecord[this.stackRecord.length - 1]
      if (prevRecord) {
        this.toggle({ left: prevRecord.left, right: prevRecord.right }, false)
      } else if (this.defaultCom) {
        this.resetDefaultCom()
      }
    },
    //清除所有记录
    clear() {
      this.components.clear()
      this.stackRecord = []
      this.currentLeft = null
      this.currentRight = null
    },
    //
    addStackRecord(record) {
      if (this.stackRecord.length >= this.maxStackSize) {
        this.stackRecord.shift()
      }
      this.stackRecord.push(record)
    },
    //设置默认显组件
    setDefaultCom(defaultCom = {}) {
      this.defaultCom = defaultCom
    },
    //重置为默认组件
    resetDefaultCom() {
      this.toggle(this.defaultCom)
    },
    //隐藏左侧组件
    hideLeft(isHide = false) {
      this.leftHide = isHide
    },
    //隐藏右侧组件
    hideRight(isHide = false) {
      this.rightHide = isHide
    }
  },
  getters: {
    //获取当前显示的组件
    activeAllComponents: (state) => {
      return {
        left: state.currentLeft,
        right: state.currentRight
      }
    },
    //获取左侧显示的组件
    activeLeftComponent: (state) => {
      return state.left
    },
    //获取右侧显示的组件
    activeRightComponent: () => {
      return state.right
    }
  },
})


// 新增：SealStatus 枚举，语义与 CorrectStatus 保持一致
export const SealStatus = {
  wait: 'WAIT', // 等待上传
  uploading: 'UPLOADING', // 上传中
  ongoing: 'ONGOING', //同步中
  complete: 'COMPLETE', // 完成
  fail: 'FAIL' // 失败
}


export const SealImgType = {
  bupai: 'bupai',
  bugai: 'bugai',
  beforeSeal: 'beforeSeal',
  afterSeal: 'afterSeal',
  ocrSeal: 'ocrSeal'
}

export const sealImgIcon = {
  [SealImgType.bupai]: bupai,
  [SealImgType.bugai]: bugai,
  [SealImgType.beforeSeal]: beforeSeal,
  [SealImgType.afterSeal]: afterSeal,
  [SealImgType.ocrSeal]: ocrSeal
}

export const sealLibraryOrigin = {
  SCANNER: 'SCANNER',
  TAKEPHOTO: 'TAKEPHOTO'
}

class SealImagesData {
  constructor({ data, path, documentId, status = SealStatus.wait, origin = sealLibraryOrigin.TAKEPHOTO }) {
    this.progress = status == SealStatus.complete ? 1 : 0.0
    this.id = 0
    this.imgData = data
    this.fullFile = ''
    this.fileId = 0
    this.status = status
    this.path = path
    this.code = 0
    this.errMsg = ''
    this.documentId = documentId
    this.origin = origin
  }
}

export const useSealImages = defineStore('sealImages', {
  state: () => {
    return {
      sealImagesMap: {},
      isPreview: false, //是否前往预览页
      previewIndex: 0,
      previewList: [],
      afterRemakeImagesMap: {} //用印后补拍图片库
    }
  },
  actions: {
    //添加上传图片
    addImage(data, sealImgType) {
      const sealImagesData = new SealImagesData(data)
      sealImagesData.status = data.status ? data.status : SealStatus.uploading
      sealImagesData.id = `seal_${Date.now()}_${Math.random().toString(36).substr(2, 6)}`
      sealImagesData.icon = sealImgIcon[sealImgType]
      this.sealImagesMap[sealImagesData.id] = sealImagesData
      console.log(this.sealImagesMap, 'sealImagesMapsealImagesMap');
      return sealImagesData.id
    },
    // 清空图片列表
    clearImageList({clearSeal = true} = {}) {
      if (clearSeal) this.sealImagesMap = {}
      this.afterRemakeImagesMap = {}
      this.imageId = 1
      this.rest()
    },
    // 根据 id 删除某一项
    removeIdImage(id) {
      delete this.sealImagesMap[id]
    },
    setIsPreview(val) {
      this.isPreview = val
    },
    rest() {
      this.isPreview = false
      this.takePhotoType = 1
      this.previewList = []
      this.previewIndex = 0
    },
    setPreviewList(val = []) {
      this.previewList = val
    },
    setPreviewIndex(val = 0) {
      this.previewIndex = val
    },
    //添加用印中的扫描图片
    addScannerImgList(list = [], sealImgType = SealImgType.bupai) {
      list.map(item => {
        item.origin = sealLibraryOrigin.SCANNER
        item.status = SealStatus.complete
        item.icon = sealImgIcon[sealImgType]
        this.addImage(item, sealImgType)
      })
    },
    //添加用印后的扫描图片
    addAfterRemakeImgList(list = [], sealImgType = SealImgType.bupai) {
      list.map(data => {
        const sealImagesData = new SealImagesData(data)
        sealImagesData.status = SealStatus.complete
        sealImagesData.id = `seal_${Date.now()}_${Math.random().toString(36).substr(2, 6)}`
        sealImagesData.icon = sealImgIcon[sealImgType]
        this.afterRemakeImagesMap[sealImagesData.id] = sealImagesData
      })
    }
  },
  getters: {
    sealImagesList: (state) => Object.values(state.sealImagesMap),
    afterRemakeImagesList: (state) => Object.values(state.afterRemakeImagesMap)
  }
})
